import { isFeatureEnabled } from '@lumapps/features';

import { IMPRESSIONS_ANALYTICS_FF } from '../constants';

export const isImpressionsAnalyticsEnabled = isFeatureEnabled(IMPRESSIONS_ANALYTICS_FF);
